import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import SupervisedUserCircleRoundedIcon from '@mui/icons-material/SupervisedUserCircleRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';

import SitemarkIcon from '../shared/components/SitemarkIcon';

const items = [
  {
    icon: <TrendingUpRoundedIcon />,
    title: 'Increased surgical confidence',
    description:
      'REPLICO provides a clear, interactive 3D model of the patient\'s anatomy and nervous system, enhancing surgical precision and preserving function.'
  },
  {
    icon: <MapRoundedIcon />,
    title: 'Improved surgical planning',
    description:
      'Surgeons can assess critical structures and plan a precise approach, reducing errors, complications, and recovery time for a better patient experience.',
  },
  {
    icon: <SupervisedUserCircleRoundedIcon />,
    title: 'Enhanced patient understanding',
    description:
      'REPLICO 3D models boost patient confidence, reduce anxiety, and set realistic expectations for postoperative outcomes.'
  },
];

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
         <SitemarkIcon sx={{ height: { xs: 28, sm: 36, md: 40 }, width: { xs: 120, sm: 160, md: 200 }, mr: 2, color: '#000000' }} />
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}
